module.exports = __webpack_public_path__ + "images/register/china-id.733701c8.jpg";